import { combineReducers } from "redux";
import header from "../../app/molecules/Header/duck/reducer";
import controlCenter from "../../app/modules/ControlCenter/ducks/reducers";
import calendar from "../../app/modules/Calendar/ducks/reducers";
import boardReducer from "../../app/modules/Ticketing/ducks/boardReducer";
import driverSlice from "../../app/modules/RtaPermit/duck/driverSlice";

const rootReducer = combineReducers({
  header,
  controlCenter,
  calendar,
  board: boardReducer,
  driver: driverSlice,
});

export default rootReducer;
